import { createAction } from "@reduxjs/toolkit";
import { addEmailActionTypes, addEmailModalType } from "./actionTypes";

export const addEmail = createAction(
  addEmailActionTypes.request,
  (payload) => ({ payload }),
);

export const addEmailSuccess = createAction(
  addEmailActionTypes.success,
  (payload) => ({ payload }),
);

export const addEmailFailure = createAction(
  addEmailActionTypes.failure,
  (error) => ({ payload: error }),
);

export const addEmailReset = createAction(addEmailActionTypes.reset);

export const toggleAddEmailModal = createAction(addEmailModalType);
